import { render, staticRenderFns } from "./liveboFangChater.vue?vue&type=template&id=5e0d82cb&scoped=true"
import script from "./liveboFangChater.vue?vue&type=script&lang=js"
export * from "./liveboFangChater.vue?vue&type=script&lang=js"
import style0 from "./liveboFangChater.vue?vue&type=style&index=0&id=5e0d82cb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0d82cb",
  null
  
)

export default component.exports